/*
For changing the position in the server, with the SetSongPosition action being triggered before it to update the UI.
This is problematic, but if we wait for the call to the server to return in the UI we will see the song jump back and forth
from the new position to the old and then back to the new only when it updates in the store
 */
import service from '../../utils/Service';

const setNewSongPositionAction = (oldPosition, newPosition, categoryId, userId) => {
   return {
      type: 'CHANGE_SONG_POSITION',
      payload: service.setNewSongPosition(oldPosition, newPosition, categoryId, userId)
   }
}

export default setNewSongPositionAction;



// WEBPACK FOOTER //
// ./src/actions/recommendations/setNewSongPositionAction.js